export * from './BaseSegment2d'
